import React from "react";
import { Box } from "@mui/material";

/* Logo officiel (public/assets/static/svg/applogo.svg), jamais redessiné :
   le même fichier est cadré deux fois, une fois sur le pictogramme (carte
   d'Afrique, atténuée par saturate(0.55)), une fois sur le mot TRIBE.
   Proportions du fichier : 130 × 184 ; pictogramme de y = 0 à 131, mot de
   y = 157 à 184. */
const SRC = "/assets/static/svg/applogo.svg";
const L = 130, H = 184, PICTO_H = 131, MOT_Y = 157, MOT_H = 27;

export default function LogoTribe({ largeurPicto = 30, largeurMot = 70 }: { largeurPicto?: number; largeurMot?: number }) {
  const echPicto = largeurPicto / L;
  const echMot = largeurMot / L;
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }} role="img" aria-label="Tribe">
      <Box sx={{ width: largeurPicto, height: PICTO_H * echPicto, overflow: "hidden", flexShrink: 0 }}>
        <img src={SRC} alt="" aria-hidden width={largeurPicto} height={H * echPicto}
          style={{ display: "block", filter: "saturate(0.55)" }} />
      </Box>
      <Box sx={{ width: largeurMot, height: MOT_H * echMot, overflow: "hidden", flexShrink: 0 }}>
        <img src={SRC} alt="" aria-hidden width={largeurMot} height={H * echMot}
          style={{ display: "block", marginTop: -MOT_Y * echMot }} />
      </Box>
    </Box>
  );
}
